import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyNumbersPipe } from './pipes/only-numbers.pipe';
import { CurrencyPipe } from './pipes/currency.pipe';
import { ImageCropperModalComponent } from '../image-cropper-modal/image-cropper-modal.component';
import { MapGeolocationComponent } from '../map-geolocation/map-geolocation.component';


@NgModule({
  declarations: [
    OnlyNumbersPipe,
    CurrencyPipe,
    ImageCropperModalComponent,
    MapGeolocationComponent
  ],
    exports: [
        OnlyNumbersPipe,
        CurrencyPipe,
        ImageCropperModalComponent,
        MapGeolocationComponent
    ],
  imports: [
    CommonModule
  ]
})
export class SharedModule { }
